module.exports = __webpack_public_path__ + "media/images/front/materials/azulejos-785e7a40d68e96140c93b4db103a7f76.jpg";